
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hjaelp",
      function () {
        return require("private-next-pages/hjaelp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hjaelp"])
      });
    }
  